import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndex } from "../model/OrganisationIndex";

export default class GetConnectionCandidatesByCategoryInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(index: IOrganisationIndex) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${index.organisationId}/indexes/${index.id}/category`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper
    );
  }
}
